import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFinchConnect } from "react-finch-connect";
import { toast } from 'react-toastify';
import TabSettings from 'components/__old/common/tabSettings.jsx';
import finch from "assets/images/logos/finch.png";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import * as integrations from "store/entities/integrations/action";

const Finch = () => {
    const dispatch = useDispatch();
    // const {finchCheckStatusLoading, finchCheckStatusResponse, finchSaveCodeLoading, finchSaveCodeStatus, finchSaveCodeResponse} = useSelector(state => state.entities.integrations);
    const {finchCheckStatusLoading, finchCheckStatusResponse, finchSaveCodeLoading} = useSelector(state => state.entities.integrations);


    const onSuccess = ({ code }) => {
        toast("Processing...")
        dispatch(integrations.finchSaveCode({code})).then(() => {
            dispatch(integrations.finchCheckStatus());
        })
    }


    const onError = ({ errorMessage }) => {
        toast.error(errorMessage);
    }

    const onClose = () => {
        // console.log("User exited Finch Connect");
        toast.error("Session closed");
    }


    // 1. Instantiate Connect
    const { open } = useFinchConnect({
        clientId: "356adfb9-9e15-435b-9911-01592c8f6f8a",
        products: ["company", "directory", "individual", "employment", "payment", "pay_statement", "benefits", "deduction"],
        category: false,
        payroll_provider: false,
        sandbox: true,
        manual: false,
        onSuccess,
        onError,
        onClose,
    });


    useEffect(() => {
        dispatch(integrations.finchCheckStatus());
        // eslint-disable-next-line
    }, [])


    return (
        <div>
            <div className="lg:flex">
                <div className="w-full lg:w-1/2">
                    <div className="page-title">
                        Settings
                    </div>
                </div>
            </div>


            <TabSettings />


            <div className="mt-8">
                <div className="box">
                    
                    <div className="w-full sm:flex sm:space-x-6 space-y-4 sm:space-y-0">
                        <div className="w-32 h-32 p-4 flex flex-shrink-0 border border-gray-300 rounded-lg">
                            <img src={finch} alt="Bento" className="object-contain m-auto" />
                        </div>

                        <div className="flex items-center">
                            <div>
                                <div>
                                    Proin eget tortor risus. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus. Sed porttitor lectus nibh. Nulla porttitor accumsan tincidunt. Cras ultricies ligula sed magna dictum porta. Vivamus suscipit tortor eget felis porttitor volutpat.
                                </div>

                                <div className="mt-3">
                                    {finchCheckStatusLoading &&
                                        <label className="btn btn-transparent-black">
                                            <FontAwesomeIcon icon="circle-notch" spin className={"text-lg mr-2"} />
                                            Checking status
                                        </label>
                                    }

                                    {!finchCheckStatusLoading && finchCheckStatusResponse.status && finchCheckStatusResponse.status === "success" &&
                                        <div className="flex space-x-4">
                                            <label className="btn text-green-500 bg-green-50">
                                                <FontAwesomeIcon icon="check-circle" className={"text-lg mr-2"} />
                                                Account connected
                                            </label>
                                            <Link to="/people/employees/crm" className="btn btn-ep-primary">
                                                View employees
                                                <FontAwesomeIcon icon="angle-right" className={"text-lg ml-2"} />
                                            </Link>
                                        </div>
                                    }

                                    {!finchCheckStatusLoading && ((!finchCheckStatusResponse.status) || (finchCheckStatusResponse.status && finchCheckStatusResponse.status !== "success")) &&
                                        <button type="button" onClick={() => open()} className="btn btn-ep-primary" disabled={finchSaveCodeLoading}>
                                            <FontAwesomeIcon icon="circle-notch" spin className={"text-xl mr-2 " + (finchSaveCodeLoading?"inline":"hidden")} />
                                            Connect your account
                                        </button>
                                    }
                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Finch
